import { Text, Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { Trans } from '@lingui/react/macro'
import { Info } from 'lucide-react'
import { useReferralsCounts, useReferralsPoints } from '../api'
import { InviteReferralButton } from './InviteReferralButton'
import { ReferralProgramInfo } from './ReferralProgramInfo'
import { ReferralsList } from './ReferralsList'

export const Referrals = () => {
  const { data: referralsCounts, isFetched: countsAreFetched } = useReferralsCounts()
  const { data: referralsPoints, isFetched: pointsAreFetched } = useReferralsPoints()

  return (
    <div className="max-tablet:flex-col flex flex-1">
      <div className="max-tablet:pb-8 max-tablet:pt-4 max-mobile:ml-0 max-mobile:w-auto max-mobile:pr-0 ml-4 flex flex-col pb-10">
        <div className="max-tablet:w-full max-tablet:pt-0 sticky top-[var(--header-height)] w-[270px] pt-10">
          <div className="max-tablet:pr-0 max-mobile:w-[unset] w-[270px] pr-10">
            <Text type="subtitle-semibold">
              <Trans>Referrals</Trans>
            </Text>
            <div className="mt-3 flex flex-col gap-4">
              <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
                <Text className="text-gray-90">
                  <Trans>Referral points</Trans>
                </Text>
                <Text type="h2">
                  {pointsAreFetched ? formatNumber(Math.round(referralsPoints?.totalPoints || 0), 0) : '-'}
                </Text>
              </div>
              <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
                <Text className="text-gray-90">
                  <Trans>Referrals</Trans>
                </Text>
                <Text>{countsAreFetched ? referralsCounts?.activatedCount || 0 : '-'}</Text>
              </div>
              <div className="flex flex-col pb-10">
                <Tooltip>
                  <TooltipTrigger>
                    <Text className="text-gray-90 flex items-center gap-2">
                      <Trans>Pending referrals</Trans> <Info size={16} className="mt-1" />
                    </Text>
                  </TooltipTrigger>
                  <TooltipContent>
                    <span>
                      <Trans>Status updates to Active after 24 hours online</Trans>
                    </span>
                  </TooltipContent>
                </Tooltip>
                <Text>{countsAreFetched ? referralsCounts?.notActivatedCount || 0 : '-'}</Text>
              </div>
            </div>
          </div>
          <InviteReferralButton />
        </div>
      </div>
      <div className="flex-grow p-5">
        <ReferralProgramInfo />
        <Text type="subtitle-semibold" className="mt-10 mb-4 block">
          <Trans>Top referrals</Trans>
        </Text>
        <ReferralsList />
      </div>
    </div>
  )
}
